import { useMediaQuery } from '@mui/material'

/** 512px以上の横幅の場合はtrue. 要はモバイルはfalseでそれ以外はtrueみたいなイメージ */
export const useIsLargeWidthDevice = () => {
  return useMediaQuery('(min-width:512px)')
}
